import {EntityModel} from "@fedeltapointofsale/data-client";
import {MembershipTypeData} from "./membership-type.data";
import {Injectable, Injector} from "@angular/core";
import {PointsData} from "../points/points.data";

@Injectable()
export class MembershipTypeEntityModel extends EntityModel<MembershipTypeData> {
    constructor(injector: Injector) {
        super(injector, MembershipTypeData);
    }

    protected override onNewEntity(membershipType: MembershipTypeData) {
        membershipType.accrualRewardRate.rewardRate.type = PointsData.TYPE_NONE;
        membershipType.redemptionRewardRate.rewardRate.type = PointsData.TYPE_NONE;
    }
}
